import { handleRequest } from '_services';
import { normalize } from 'normalizr';
import { patientsSchema, fotoEpisodesSchema, episodeTherapistSchema } from '_services/_schemas';
import { getDateYYYYMMDD } from '_helpers';

export const patientService = {
    load,
    updatePatientNotes,
    updatePatientContrain,
    enableRtm,
    loadDiary,
    requestSpecialProg,
    loadPeerReviews,
    loadCdv,
    addDiag,
    removeDiag,
    copyDiags,
    updateDiagOnset,
    loadPoc,
    loadFotoEpisodes,
    refreshFoto,
    getAdmissionTherapists,
    refreshFotoForPatient,
    changeFotoClaimStatus,
    refreshAdmissions,
    openHEP,
    createRtm,
    refreshScans,
    setUsePeds,
    loadSupervisors,
    updateSupervisor
};

async function load(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/load?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}


async function refreshAdmissions(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/refreshadmissions?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function setUsePeds(epno, usePeds) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/setusepeds?epno=' + epno + '&usepeds=' + usePeds, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}


async function updatePatientNotes(ptno, notes) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ptno, notes })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/updatepatientnotes', requestOptions, true);
}

async function updatePatientContrain(epno, contrain) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, contrain })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/updateadmissioncontrain', requestOptions, true);
}

async function enableRtm(epno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/enablertm', requestOptions, true);
}

async function loadDiary(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/loaddiary?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function requestSpecialProg(epno, type, note) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, type, note })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/requestspecialprog', requestOptions, true);
}

async function loadPeerReviews(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/loadpeerreviews?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function loadCdv(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/loadcdv?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function loadSupervisors(id, noteType, epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/getsupervisingtherapists?id=' + id+'&notetype='+noteType+'&epno='+epno , requestOptions, true)
        .then(data => {
            return data;
        });
}

async function updateSupervisor(id, noteType, supervisorId) {
    const requestOptions = {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, noteType, supervisorId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/updatesupervisingtherapists', requestOptions, true)
        .then(data => {
            return data;
        });
}

async function addDiag(epno, diag, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, diag, type })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/adddiag', requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function removeDiag(epno, diag, type) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, diag, type })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/removediag', requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function copyDiags(epno) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/copyalldiag', requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function updateDiagOnset(epno, position, type, onsetDate) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, position, type, onsetDate: onsetDate === '' ? null : getDateYYYYMMDD(onsetDate) })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/updatediagonset', requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function loadPoc(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/loadpoc?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function loadFotoEpisodes(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/loadfotoepisodes?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, fotoEpisodesSchema);
            return flat;
        });
}

async function refreshFoto(epno, noteID) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/refreshfotoepisodes?epno=' + epno + "&noteID=" + noteID, requestOptions, true)
        .then(data => {
            var flat = normalize(data, fotoEpisodesSchema);
            return flat;
        });
}

async function getAdmissionTherapists(epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/getadmissiontherapists?epno=' + epno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, episodeTherapistSchema);
            return flat;
        });
}


async function refreshFotoForPatient(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/refreshfotoepisodesforpatient?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

async function changeFotoClaimStatus(epno, unclaimEpisodeId, claimEpisodeId) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, unclaimEpisodeId, claimEpisodeId })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/changefotoclaimstatus', requestOptions, true)
        .then(data => {
            var flat = normalize(data, fotoEpisodesSchema);
            return flat;
        });
}

async function openHEP(epno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/openhep?epno=' + epno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });

}

async function createRtm(epno, rtmDetails, rtm98975Date, rtm98975, rtm98975Assist, rtm98977Date, rtm98977, rtm98980Date, rtm98980, rtm98980Assist, rtm98981Date, rtm98981, rtm98981Assist) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ epno, rtmDetails, rtm98975Date, rtm98975, rtm98975Assist, rtm98977Date, rtm98977, rtm98980Date, rtm98980, rtm98980Assist, rtm98981Date, rtm98981, rtm98981Assist })
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/creatertm', requestOptions, true);
}

async function refreshScans(ptno) {
    const requestOptions = {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
    };

    return await handleRequest(process.env.REACT_APP_API_URI + '/patients/refreshscans?ptno=' + ptno, requestOptions, true)
        .then(data => {
            var flat = normalize(data, patientsSchema);
            return flat;
        });
}

